// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2MKpz","label":"SetPasswdForm_label__3S4sl"};